import api from "./api";
export const getFuelTypeDropdown = async (fuelTypeId: string = "") => {
  const response = await api.post("/fuel-type/getAll", {
    FuelTypeID: fuelTypeId,
  });
  return response.data.data;
};